export enum ColorGradient {
  Reds = "Reds",
  Blues = "Blues",
  Greens = "Greens",
  GreenRed = "GreenRed",
  Spectral = "Spectral",
  Azure = "Azure",
  Magma = "Magma",
  Tranquil = "Tranquil",
  Pastel = "Pastel",
}
